export default "__VITE_ASSET__Eoy8N8ol__"